
































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CreditCardCard extends Vue {
  @Prop()
  public last4!: string;

  @Prop()
  public expMonth!: number;

  @Prop()
  public expYear!: number;

  @Prop()
  public brand!: 'visa' | 'mastercard';

  @Prop({ default: false })
  public isSelected!: boolean;

  public get formattedBrand() {
    return this.brand
      .toLowerCase()
      .split(' ')
      .join('-');
  }
}
